import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=33f9b2ea&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33f9b2ea')) {
      api.createRecord('33f9b2ea', component.options)
    } else {
      api.reload('33f9b2ea', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=33f9b2ea&", function () {
      api.rerender('33f9b2ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2vitfXyMghxn7/JS/cancellationPolicy.vue"
export default component.exports